import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Autocomplete } from '@mui/material'
import Textfield from '../FormsUI/Textfield'
import { getPseudonymsBySpecieId } from '../../services'

import { Chip } from '@mui/material'
import { setEnablePseudonymField } from '../../redux/slices/Tree/treeFeatures'
import _ from 'lodash'

const InputBasic = ({ data, options, variant, label, editable, ...rest }) => {
  const dispatch = useDispatch()
  const [filterList1, setSelectedList] = React.useState(data)
  const [optionsList, setOptionsList] = React.useState(options)

  const inputError = useSelector(
    state => state.treeFeatures.enableSaveButton.pseudonymField
  )
  const specieSelected = useSelector(
    state => state.treeFeatures.enableSaveButton.specieField?.selected
  )

  const handleOnBlur = () => {
    if (!inputError.error && !Boolean(filterList1.length))
      dispatch(setEnablePseudonymField({ error: true, helperText: 'Obligatorio' }))
  }

  const handleSelection = (event, newList) => {
    let newListFormat = []
    _.forEach(newList, o => {
      if (!o.name) {
        const existsPreviously = _.some(newList, ['name', o])
        if (!existsPreviously) newListFormat.push({ name: o })
      } else newListFormat.push(o)
    })
    setSelectedList(newListFormat)

    !newListFormat.length
      ? dispatch(setEnablePseudonymField({ error: true, helperText: 'Obligatorio' }))
      : dispatch(setEnablePseudonymField({ error: false, selected: newListFormat }))
  }

  const handelEqualValue = (option, value) => option.name === value.name

  React.useEffect(() => {
    dispatch(setEnablePseudonymField({ error: false, selected: filterList1 }))
    return () => {
      if (!filterList1.length)
        dispatch(setEnablePseudonymField({ error: false, selected: undefined }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  React.useEffect(() => {
    if (!Boolean(specieSelected)) return
    getPseudonymsBySpecieId(parseInt(specieSelected.id, 10))
      .then(optionsOfSpecie => setOptionsList(optionsOfSpecie))
      .catch(err => console.log('Error :>> ', err))
  }, [specieSelected])

  return (
    <Autocomplete
      multiple
      id={`pseudonym-inputs`}
      size="small"
      name={rest.name}
      value={filterList1}
      onChange={handleSelection}
      options={optionsList}
      readOnly={!editable}
      getOptionLabel={option => option.name}
      isOptionEqualToValue={handelEqualValue}
      onBlur={handleOnBlur}
      freeSolo
      disableClearable
      renderTags={(value, getTagProps) => {
        return value.map((option, index) => {
          if (!option.name) option = { name: option }
          return (
            <Chip variant="outlined" label={option.name} {...getTagProps({ index })} />
          )
        })
      }}
      renderInput={params => {
        return (
          <Textfield
            {...params}
            name={rest.name}
            value={filterList1}
            variant={variant}
            label={label}
            placeholder={editable ? 'Nuevo Item [ENTER]' : undefined}
            error={inputError.error}
            helperText={inputError.helperText}
          />
        )
      }}
      style={{ width: '100%' }}
    />
  )
}
export default InputBasic
